/**
 * Podcast Transcript - Auto-bold speaker names
 * Finds text patterns like "Name Name:" or "Dr. Name:" at the start of
 * paragraph text and wraps them in <strong class="speaker-name">
 */
(function ($) {
    'use strict';

    function boldSpeakerNames() {
        var $transcript = $('.podcast-transcript');
        if (!$transcript.length) return;

        $transcript.find('p').each(function () {
            var $p = $(this);
            var html = $p.html();

            // Match speaker name at start of paragraph:
            // Optional title (Dr./Mr./Mrs./Ms.) + one or more capitalized words, ending with colon
            // e.g. "Mar Houstin:", "Dr. Marsland:", "Dr. Jane Smith:"
            var replaced = html.replace(
                /^((?:(?:Dr|Mr|Mrs|Ms)\.?\s+)?[A-Z][a-zA-Z]+(?:\s+[A-Z][a-zA-Z]+)*:)/,
                '<strong class="speaker-name">$1</strong>'
            );

            if (replaced !== html) {
                $p.html(replaced);
            }
        });
    }

    $(document).ready(function () {
        boldSpeakerNames();

        // Re-run when a tab is shown (covers transcript tab activation)
        $('[data-bs-toggle="pill"]').on('shown.bs.tab', function () {
            boldSpeakerNames();
        });
    });
})(jQuery);
